import angular from 'angular';
import noteModal from './noteModal';
import './style.scss';

export default angular
  .module('components.noteModal', [])
  .component('noteModal', noteModal).name;
